<template functional>
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 541.4 541.4" style="fill:none;stroke:#000;stroke-width:24.81px"><rect class="cls-1" x="10.1" y="10.1" width="521.2" height="521.2" rx="62"/><line class="cls-1" x1="10.1" y1="137.09" x2="531.3" y2="137.09"/><line class="cls-1" x1="7.3" y1="206" x2="528.49" y2="206"/><circle cx="69.36" cy="62.65" r="13.36"/><circle cx="116.13" cy="62.65" r="13.36"/><circle cx="162.9" cy="62.65" r="13.36"/></svg>
</template>

<script>
export default {}
</script>
